import React from "react";
import { SelectInputComponent } from "../../../../common/components";
import { STATUS_OPTIONS } from "../../../../constants/campaignDropdown";
import "./filter-options-select.scss"
interface LeadStatusFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isLeadStatusEnabled?: boolean;
  leadStatusError?: any;
}

const LeadStatusFilter: React.FC<LeadStatusFilterProps> = ({
  value,
  onChange,
  isLeadStatusEnabled,
  leadStatusError
}) => {
  if (!isLeadStatusEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="status"
        options={STATUS_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Status"
        multiple={true}
        isFilter={true}
      />
      {leadStatusError && <div className="error-text">{leadStatusError}</div>}
    </div>
  );
};

export default LeadStatusFilter;
